import { Button, LoadingSpinner, TermsOfService as ToS, PageAlert } from "@xapp/components";
import { ClientApp } from "models";

import React, { FC, useCallback } from "react";

export interface TermsOfService {
    content: { rendered: string };
    link: string;
    modified_gmt: string;
    accepted?: boolean;
}

export interface CheckoutStepProps {
    /**
     * Error message to display to the user if something goes wrong.
     */
    error?: { error: string, message: string };
    /**
     * If we are gathering information for checkout
     */
    loading?: boolean;
    /**
     * Message to display while loading
     */
    loadingMessage?: string;
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * App that the subscription will be applied to
     */
    app: Pick<ClientApp, "appId" | "organizationId" | "name">;
    /**
     * Terms of Service the user may or may not have already accepted
     */
    termsOfService?: TermsOfService;
    /**
     * User has accepted the terms of service
     */
    onAcceptTermsOfService(): void;
    /**
     * User requests to checkout
     */
    onCheckout(): void;
    /**
     * User has requested the next step
     */
    onNextStep?(): void;
}

/**
 * Display terms and checkout (optional)
 */
export const CheckoutStep: FC<CheckoutStepProps> = props => {

    const {
        error,
        loading,
        loadingMessage,
        style,
        termsOfService,
        className,
        onAcceptTermsOfService,
        onCheckout
    } = props;

    const tosAccepted: boolean = termsOfService?.accepted;

    const getContent = useCallback(() => {

        // if terms of service not accepted
        if (!tosAccepted) {
            return (
                <ToS
                    terms={termsOfService?.content?.rendered}
                    onAccept={onAcceptTermsOfService}
                />
            );
        } else {
            return (
                < div >
                    <h3>Checkout</h3>
                    <p>Thanks!  To complete checking out, please click below.</p>
                    <div style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Button
                            leftIcon="verified"
                            label={`Checkout`}
                            variation="primary"
                            onClick={onCheckout}
                        />
                    </div>
                </div>
            );
        }
    }, [tosAccepted, termsOfService?.content?.rendered, onAcceptTermsOfService, onCheckout])

    return (
        <div style={{ ...style }} className={className}>
            {error ? (
                <PageAlert background="orange" >
                    <p>{error.message}</p>
                    <pre style={{ overflow: "scroll" }}>{error.error}</pre>
                    {/**We need a call to action for them to get help */}
                </PageAlert>
            ) : (<></>)}
            {loading ? (
                <LoadingSpinner loadingText={loadingMessage} />
            ) : (getContent())}
        </div >
    );
}